<template>
  <div class="appointment-freight-pricing-scheme">
    <el-card class="box-card" shadow="never">
      
      <!-- 搜索条件 -->
      <div class="search-toolbar">
        <el-form :inline="true" :model="searchForm" size="small" class="search-form">
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="searchForm.createTimeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              style="width: 300px;"
            />
          </el-form-item>
          
          <el-form-item label="保险公司">
            <el-select 
              v-model="searchForm.insuranceType" 
              placeholder="请选择保险公司" 
              clearable 
              filterable
              style="width: 200px;"
            >
              <el-option 
                v-for="item in insuranceCompanyList" 
                :key="item.id" 
                :label="item.name" 
                :value="item.id" 
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label="签署公司">
            <el-input v-model="searchForm.companyName" placeholder="公司名称" style="width: 240px;" clearable />
          </el-form-item>
          
          <el-form-item label="结算渠道">
            <el-select v-model="searchForm.settlementChannel" placeholder="请选择结算渠道" clearable style="width: 150px;">
              <el-option label="中际心元" value="2" />
              <el-option label="鼎盛" value="4" />
            </el-select>
          </el-form-item>
          
          <el-form-item label="出单方案">
            <el-select v-model="searchForm.policyName" placeholder="请选择出单方案" clearable style="width: 300px;">
              <el-option 
                v-for="option in policyNameOptions" 
                :key="option.value" 
                :label="option.label" 
                :value="option.value" 
              />
            </el-select>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
        
        <!-- 操作按钮 -->
        <div class="toolbar-right">
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd">创建价格方案</el-button>
          <el-button type="success" icon="el-icon-download" @click="handleExport">导出Excel</el-button>
        </div>
      </div>
      
      <!-- 数据表格 -->
      <div class="table-container">
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          stripe
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="priceSchemeName" label="价格方案" min-width="250" show-overflow-tooltip />
        <el-table-column prop="companyName" label="签署协议的公司名称" min-width="180" show-overflow-tooltip />
        <el-table-column prop="insuranceType" label="保险公司类型" width="220" show-overflow-tooltip />
        <el-table-column prop="agreementNo" label="协议号" width="120" show-overflow-tooltip />
        <el-table-column prop="settlementChannel" label="结算渠道" width="100" show-overflow-tooltip />
        <el-table-column prop="onlineRecharge" label="是否在线充值" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.onlineRecharge === '是' ? 'success' : 'danger'">
              {{ scope.row.onlineRecharge }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="autoPay" label="是否自动支付" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.autoPay === '是' ? 'success' : 'danger'">
              {{ scope.row.autoPay }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="onlinePolicy" label="是否在线出单" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.onlinePolicy === '是' ? 'success' : 'danger'">
              {{ scope.row.onlinePolicy }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="policyName" label="出单方案名称" min-width="200" show-overflow-tooltip />
        <el-table-column prop="confirmationType" label="承保确认单样式" width="140" show-overflow-tooltip />
        <el-table-column prop="effectiveTime" label="生效时间" width="120" show-overflow-tooltip />
        <el-table-column prop="expireTime" label="失效时间" width="120" show-overflow-tooltip />
        <el-table-column prop="agreementScanUrl" label="协议扫描件" width="120">
          <template slot-scope="scope">
            <el-button v-if="scope.row.agreementScanUrl" size="mini" type="text" @click="viewAgreement(scope.row.agreementScanUrl)">
              查看
            </el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="feeSchemeType" label="费用方案类型" width="120" show-overflow-tooltip />
        <el-table-column prop="rate" label="费率" width="80" show-overflow-tooltip />
        <el-table-column prop="minPremium" label="最低保费" width="100" show-overflow-tooltip />
        <el-table-column prop="maxLimit" label="最高限额" width="100" show-overflow-tooltip />
        <el-table-column prop="policyValidPeriod" label="保单有效期" width="120" show-overflow-tooltip />
        <el-table-column prop="deductible" label="免赔额/率" width="100" show-overflow-tooltip />
        <el-table-column prop="excludedGoods" label="不保货物" min-width="150" show-overflow-tooltip />
        <el-table-column prop="specialAgreement" label="电子保单特别约定" min-width="150" show-overflow-tooltip />
        <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="160" show-overflow-tooltip />
        <el-table-column prop="updateTime" label="更新时间" width="160" show-overflow-tooltip />
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        </el-table>
      </div>
      
      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 15, 20, 50, 100]"
          :page-size="pagination.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        />
      </div>
    </el-card>
    
    <!-- 创建/编辑价格方案对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="900px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
      class="pricing-scheme-dialog"
    >
      <el-form
        ref="schemeForm"
        :model="schemeForm"
        :rules="schemeRules"
        label-width="140px"
        size="small"
      >
        <!-- 方案信息设置 -->
        <div class="form-section">
          <h4 class="section-title">|| 方案信息设置</h4>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="生效时间" prop="effectiveTime">
                <el-date-picker
                  v-model="schemeForm.effectiveTime"
                  type="date"
                  placeholder="选择生效时间"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="失效时间" prop="expireTime">
                <el-date-picker
                  v-model="schemeForm.expireTime"
                  type="date"
                  placeholder="选择失效时间"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item label="协议扫描件" prop="agreementScanUrl">
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :headers="uploadHeaders"
              name="fileVal"
              :before-upload="handleBeforeUpload"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :show-file-list="false"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传PDF/JPG/PNG文件，且不超过10MB</div>
            </el-upload>
            <div v-if="schemeForm.agreementScanUrl" class="upload-success">
              上传成功！<a :href="schemeForm.agreementScanUrl" target="_blank">查看</a>
            </div>
          </el-form-item>
          
          <el-form-item label="方案名称" prop="priceSchemeName">
            <el-input
              v-model="schemeForm.priceSchemeName"
              placeholder="请输入方案名称"
              style="width: 300px"
            />
          </el-form-item>
          
          <el-form-item label="签署协议的公司名称" prop="companyName">
            <el-input
              v-model="schemeForm.companyName"
              placeholder="对应订单中的投保人，请勿随意修改"
              style="width: 300px"
            />
          </el-form-item>
          
          <el-form-item label="保险公司类型" prop="insuranceType">
            <el-select
              v-model="schemeForm.insuranceType"
              placeholder="请选择保险公司类型"
              clearable
              filterable
              style="width: 300px"
            >
              <el-option 
                v-for="item in insuranceCompanyList" 
                :key="item.id" 
                :label="item.name" 
                :value="item.id" 
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label="结算渠道" prop="settlementChannel">
            <el-select
              v-model="schemeForm.settlementChannel"
              placeholder="请选择结算渠道"
              style="width: 170px"
            >
              <el-option label="恒丰经纪" value="1" />
              <el-option label="中际心元" value="2" />
              <el-option label="鼎盛" value="4" />
            </el-select>
          </el-form-item>
        </div>
        
        <!-- 承保出单设置 -->
        <div class="form-section">
          <h4 class="section-title">|| 承保出单设置</h4>
          
          <el-form-item label="发送邮件">
            <el-radio-group v-model="schemeForm.sendEmail">
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item v-if="schemeForm.sendEmail === 1" label="邮箱地址" prop="email">
            <el-input
              v-model="schemeForm.email"
              placeholder="请输入邮箱地址"
              style="width: 300px"
            />
          </el-form-item>
          
          <el-form-item label="在线充值">
            <el-radio-group v-model="schemeForm.onlineRecharge">
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item label="自动支付">
            <el-radio-group v-model="schemeForm.autoPay">
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item label="在线出单">
            <el-radio-group v-model="schemeForm.onlinePolicy">
              <el-radio :label="0">关闭</el-radio>
              <el-radio :label="1">开启</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item v-if="schemeForm.onlinePolicy === 1" label="出单方案名称" prop="policyName">
            <el-select
              v-model="schemeForm.policyName"
              placeholder="请选择出单方案"
              style="width: 320px"
            >
              <el-option 
                v-for="option in policyNameOptions" 
                :key="option.value" 
                :label="option.label" 
                :value="option.value" 
              />
            </el-select>
          </el-form-item>
          
          <el-form-item v-if="schemeForm.onlinePolicy === 0" label="承保确认单样式" prop="confirmationType">
            <el-select
              v-model="schemeForm.confirmationType"
              placeholder="请选择承保确认单样式"
              style="width: 320px"
            >
              <el-option 
                v-for="option in confirmationTypeOptions" 
                :key="option.value" 
                :label="option.label" 
                :value="option.value" 
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label="保单期限">
            <el-input
              v-model="schemeForm.policyValidPeriod"
              placeholder="默认为10天"
              style="width: 300px"
            />
          </el-form-item>
          
          <el-form-item label="不保地区">
            <el-radio-group v-model="schemeForm.isCityForbid">
              <el-radio :label="false">关闭</el-radio>
              <el-radio :label="true">开启</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item v-if="schemeForm.isCityForbid" label="不保地区选择">
            <el-tree
              ref="forbidCityTree"
              :data="cityTreeData"
              show-checkbox
              node-key="id"
              :props="{ children: 'children', label: 'text' }"
              style="max-height: 200px; overflow-y: auto; border: 1px solid #dcdfe6; padding: 10px;"
              @check="handleForbidCityCheck"
            />
          </el-form-item>
        </div>
        
        <!-- 加费设置 -->
        <div class="form-section">
          <h4 class="section-title">|| 加费设置</h4>
          
          <el-form-item label="超牌车辆">
            <el-radio-group v-model="schemeForm.isSuperCard">
              <el-radio :label="false">拒绝承保</el-radio>
              <el-radio :label="true">允许承保</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item v-if="schemeForm.isSuperCard" label="超牌加费">
            <el-radio-group v-model="schemeForm.superCardFree">
              <el-radio :label="1">无需加费</el-radio>
              <el-radio :label="2">固定金额</el-radio>
              <el-radio :label="4" :disabled="schemeForm.feeSchemeType === '3'">固定费率</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item v-if="schemeForm.isSuperCard && schemeForm.superCardFree !== 1" :label="schemeForm.superCardFree === 2 ? '超牌加费金额' : '超牌加费费率(%)'">
            <el-input
              v-model="schemeForm.superCardAmount"
              :placeholder="schemeForm.superCardFree === 2 ? '请输入加费金额' : '请输入加费费率'"
              style="width: 300px"
            />
          </el-form-item>
          
          <el-form-item label="地区加费">
            <el-radio-group v-model="schemeForm.isCityFree">
              <el-radio :label="false">无</el-radio>
              <el-radio :label="true">有</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item v-if="schemeForm.isCityFree" label="加费地区选择">
            <el-tree
              ref="addFreeCityTree"
              :data="cityTreeData"
              show-checkbox
              node-key="id"
              :props="{ children: 'children', label: 'text' }"
              style="max-height: 200px; overflow-y: auto; border: 1px solid #dcdfe6; padding: 10px;"
              @check="handleAddFreeCityCheck"
            />
          </el-form-item>
          
          <el-form-item v-if="schemeForm.isCityFree" label="地区加费类型">
            <el-radio-group v-model="schemeForm.cityFree">
              <el-radio :label="1">固定金额</el-radio>
              <el-radio :label="2" :disabled="schemeForm.feeSchemeType === '3'">固定费率</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item v-if="schemeForm.isCityFree" :label="schemeForm.cityFree === 1 ? '地区加费金额' : '地区加费费率(%)'">
            <el-input
              v-model="schemeForm.cityAmount"
              :placeholder="schemeForm.cityFree === 1 ? '请输入加费金额' : '请输入加费费率'"
              style="width: 300px"
            />
          </el-form-item>
        </div>
        
        <!-- 保险费率设置 -->
        <div class="form-section">
          <h4 class="section-title">|| 保险费率设置</h4>
          
          <el-form-item label="计费方式" prop="feeSchemeType">
            <el-select
              v-model="schemeForm.feeSchemeType"
              placeholder="请选择计费方式"
              style="width: 170px"
            >
              <el-option label="保额*费率" value="1" />
              <el-option label="运费*费率" value="2" />
              <el-option label="固定费用" value="3" />
            </el-select>
          </el-form-item>
          
          <el-form-item v-if="schemeForm.feeSchemeType !== '3'" label="费率(%)" prop="rate">
            <el-input
              v-model="schemeForm.rate"
              placeholder="请输入费率"
              style="width: 300px"
            />
          </el-form-item>
          
          <el-form-item label="最低保费(元)" prop="minPremium">
            <el-input
              v-model="schemeForm.minPremium"
              placeholder="请输入最低保费"
              style="width: 300px"
            />
          </el-form-item>
          
          <el-form-item label="最高限额(元)" prop="maxLimit">
            <el-input
              v-model="schemeForm.maxLimit"
              placeholder="请输入最高限额"
              style="width: 300px"
            />
          </el-form-item>
        </div>
        
        <!-- 方案详细信息设置 -->
        <div class="form-section">
          <h4 class="section-title">|| 方案详细信息设置</h4>
          
          <el-form-item label="免赔额/率" prop="deductible">
            <el-input
              v-model="schemeForm.deductible"
              type="textarea"
              :rows="3"
              placeholder="请输入免赔额/率"
              style="width: 500px"
            />
          </el-form-item>
          
          <el-form-item label="特别约定" prop="specialAgreement">
            <el-input
              v-model="schemeForm.specialAgreement"
              type="textarea"
              :rows="6"
              placeholder="请输入特别约定"
              style="width: 500px"
            />
          </el-form-item>
          
          <el-form-item label="不保货物" prop="excludedGoods">
            <el-input
              v-model="schemeForm.excludedGoods"
              type="textarea"
              :rows="6"
              placeholder="请输入不保货物"
              style="width: 500px"
            />
          </el-form-item>
          
          <el-form-item label="保险条款" prop="protocolContent">
            <el-input
              v-model="schemeForm.protocolContent"
              type="textarea"
              :rows="6"
              placeholder="请输入保险协议"
              style="width: 500px"
            />
          </el-form-item>

          <el-form-item label="附加条款" prop="additionalClauses">
            <el-input
              v-model="schemeForm.additionalClauses"
              type="textarea"
              :rows="6"
              placeholder="请输入附加条款"
              style="width: 500px"
            />
          </el-form-item>

          <el-form-item label="保险责任" prop="insuranceLiability">
            <el-input
              v-model="schemeForm.insuranceLiability"
              type="textarea"
              :rows="6"
              placeholder="请输入保险责任"
              style="width: 500px"
            />
          </el-form-item>
          
          <el-form-item label="备注">
            <el-input
              v-model="schemeForm.remark"
              type="textarea"
              :rows="3"
              placeholder="请输入备注"
              style="width: 500px"
            />
          </el-form-item>
        </div>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import { getHyxPriceList, getCityList, getConfirmationTypeList, getPolicyNameList, deleteHyxPriceScheme } from '@/api/hyx-order'
import { getHyxPriceDetail, saveHyxPrice } from '@/api/member'
import { getInsuranceCompanyList } from '@/api/claim'
import CITIES_DATA from '@/lib/cities-data'

export default {
  name: 'AppointmentFreightPricingScheme',
  data() {
    return {
      // 搜索相关
      searchForm: {
        createTimeRange: [],
        insuranceType: '',
        companyName: '',
        settlementChannel: '',
        policyName: ''
      },
      
      // 表格数据
      loading: false,
      tableData: [],
      
      // 分页信息
      pagination: {
        page: 1,
        rows: 15,
        total: 0
      },
      
      // 模拟数据（用于开发测试）
      mockTableData: [],
      selectedRows: [],
      // 保险公司列表
      insuranceCompanyList: [],
      // 对话框相关
      dialogVisible: false,
      dialogTitle: '创建价格方案',
      isEdit: false,
      submitLoading: false,
      schemeForm: {
        id: null,
        priceSchemeName: '',
        companyName: '',
        insuranceType: '',
        settlementChannel: '',
        policyName: '',
        confirmationType: '',
        onlineRecharge: 1,
        autoPay: 0,
        onlinePolicy: 1,
        sendEmail: 0,
        email: '',
        effectiveTime: '',
        expireTime: '',
        feeSchemeType: '',
        rate: '',
        minPremium: '',
        maxLimit: '',
        deductible: '',
        policyValidPeriod: '',
        agreementScanUrl: '',
        excludedGoods: '',
        specialAgreement: '',
        protocolContent: '',
        additionalClauses: '',
        insuranceLiability: '',
        remark: '',
        // 新增字段：不保地区
        isCityForbid: false,
        forbidCityList: [],
        // 新增字段：超牌车辆
        isSuperCard: false,
        superCardFree: 1, // 1-无需加费 2-固定金额 4-固定费率
        superCardAmount: '',
        // 新增字段：地区加费
        isCityFree: false,
        cityFree: 1, // 1-固定金额 2-固定费率
        cityAmount: '',
        addFreeCityList: []
      },
      schemeRules: {
        priceSchemeName: [
          { required: true, message: '请输入价格方案名称', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请输入签署协议的公司名称', trigger: 'blur' }
        ],
        insuranceType: [
          { required: true, message: '请选择保险公司类型', trigger: 'change' }
        ],
        agreementNo: [
          { required: true, message: '请输入协议号', trigger: 'blur' }
        ],
        settlementChannel: [
          { required: true, message: '请选择结算渠道', trigger: 'change' }
        ],
        policyName: [
          { required: true, message: '请选择出单方案名称', trigger: 'change' }
        ],
        effectiveTime: [
          { required: true, message: '请选择生效时间', trigger: 'change' }
        ],
        expireTime: [
          { required: true, message: '请选择失效时间', trigger: 'change' }
        ],
        feeSchemeType: [
          { required: true, message: '请选择费用方案类型', trigger: 'change' }
        ],
        rate: [
          { required: true, message: '请输入费率', trigger: 'blur' }
        ],
        minPremium: [
          { required: true, message: '请输入最低保费', trigger: 'blur' }
        ],
        agreementScanUrl: [
          { required: true, message: '请输入协议扫描件地址', trigger: 'blur' }
        ]
      },
      // 选项数据
      insuranceTypeOptions: [
        { value: '1', label: '平安保险' },
        { value: '2', label: '太平洋保险' },
        { value: '3', label: '人保财险' },
        { value: '4', label: '中华联合' }
      ],
      settlementChannelOptions: [
        { value: '1', label: '线上结算' },
        { value: '2', label: '线下结算' },
        { value: '3', label: '混合结算' }
      ],
      feeSchemeTypeOptions: [
        { value: '1', label: '按货值计费' },
        { value: '2', label: '按重量计费' },
        { value: '3', label: '固定费用' }
      ],
      policyNameOptions: [],
      confirmationTypeOptions: [
        { value: '1', label: '标准确认单' },
        { value: '2', label: '简化确认单' },
        { value: '3', label: '详细确认单' }
      ],
      form: {
        id: null,
        schemeName: '',
        description: '',
        minCargoValue: null,
        maxCargoValue: null,
        rate: null,
        minPremium: null,
        status: '1'
      },
      rules: {
        schemeName: [
          { required: true, message: '请输入方案名称', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入方案描述', trigger: 'blur' }
        ],
        minCargoValue: [
          { required: true, message: '请输入最小货值', trigger: 'blur' }
        ],
        maxCargoValue: [
          { required: true, message: '请输入最大货值', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value && this.form.minCargoValue && value <= this.form.minCargoValue) {
                callback(new Error('最大货值必须大于最小货值'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        rate: [
          { required: true, message: '请输入费率', trigger: 'blur' }
        ],
        minPremium: [
          { required: true, message: '请输入最低保费', trigger: 'blur' }
        ]
      },
      // 文件上传URL
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || process.env.VUE_APP_BASE_URL + '/res/file/upload',
      // 文件上传请求头
      uploadHeaders: {
        'Authorization': 'Bearer ' + (localStorage.getItem('jubao_admin_token') || localStorage.getItem('jubao_admin') || '')
      },
      // 城市树数据
      cityTreeData: [],
      // 承保确认单样式选项
      confirmationTypeOptions: []
    }
  },
  created() {
    this.fetchInsuranceCompanyList().then(()=>{
      this.fetchData()
      this.fetchCityList()
      this.fetchConfirmationTypeList()
      this.fetchPolicyNameOptions()
    })
  },
  methods: {
    // 获取数据
    async fetchData() {
      this.loading = true
      try {
        const params = this.getSearchParams()
        const response = await getHyxPriceList(params)
        
        if (response && response.err_code === 0) {
          // 处理真实API数据，进行字段映射
          this.tableData = (response.rows || []).map(item => this.mapApiDataToTableData(item))
          this.pagination.total = response.total || 0
        } else {
          this.$message.error('获取数据失败：' + (response.err_msg || '未知错误'))
        }
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败：' + (error.message || '网络错误'))
      } finally {
        this.loading = false
      }
    },
    
    // 获取保险公司列表
    async fetchInsuranceCompanyList() {
      try {
        const response = await getInsuranceCompanyList()
        if (response && response.err_code === 0) {
          this.insuranceCompanyList = response.rows || []
        }
      } catch (error) {
        console.error('获取保险公司列表失败:', error)
      }
    },
    
    // 将API返回的数据字段映射到表格所需的字段
    mapApiDataToTableData(apiData) {
      return {
        id: apiData.id,
        priceSchemeName: apiData.name || '',
        companyName: apiData.company_name || '',
        insuranceType: this.formatInsuranceType(apiData.insurance_type), // 显示保险公司名称
        agreementNo: apiData.agreement_no || apiData.protocol_no || '',
        settlementChannel: this.formatSettlementChannel(apiData.settlement_channel),
        onlineRecharge: this.formatBooleanValue(apiData.is_deposit_online),
        autoPay: this.formatBooleanValue(apiData.is_auto_pay),
        onlinePolicy: this.formatBooleanValue(apiData.is_get_policy),
        policyName: apiData.policy_name_desc || apiData.name || '',
        confirmationType: this.formatConfirmationType(apiData.confirmation_type),
        effectiveTime: this.formatDate(apiData.effected_at) || '',
        expireTime: this.formatDate(apiData.expired_at) || '',
        agreementScanUrl: apiData.protocol_content || '',
        feeSchemeType: this.formatFeeSchemeType(apiData.calculate_type),
        rate: this.formatRate(apiData.premium_rate),
        minPremium: this.formatMoney(apiData.min_premium),
        maxLimit: this.formatMoney(apiData.max_coverage),
        policyValidPeriod: apiData.effect_days ? apiData.effect_days + '天' : '',
        deductible: apiData.deductible || '',
        excludedGoods: apiData.warranty_against_cargo || '',
        specialAgreement: apiData.terms || '',
        protocolContent: apiData.protocol_content || '',
        additionalClauses: apiData.additional_clauses || '',
        insuranceLiability: apiData.insurance_liability || '',
        remark: apiData.note || '',
        createTime: this.formatDate(apiData.created_at),
        updateTime: this.formatDate(apiData.updated_at)
      }
    },
    
    // 格式化费用方案类型
    formatFeeSchemeType(value) {
      const types = {
        1: '保额*费率',
        2: '运费*费率',
        3: '固定费用'
      }
      return types[value] || '按货值'
    },
    
    // 格式化承保确认单样式
    formatConfirmationType(value) {
      if (!value) return ''
      
      // 从选项列表中查找对应的标签
      const option = this.confirmationTypeOptions.find(item => item.value === String(value))
      return option ? option.label : value
    },
    
    // 格式化费率
    formatRate(value) {
      if (value) {
        return (value / 10000).toFixed(4) + '%'
      }
      return ''
    },
    
    // 格式化金额
    formatMoney(value) {
      if (value != null) {
        return new Intl.NumberFormat('zh-CN', {
          style: 'currency',
          currency: 'CNY'
        }).format(value)
      }
      return ''
    },
    
    // 格式化日期
    formatDate(date) {
      if (date === undefined || date === null || date === '') {
        return ''
      }
      
      let timestamp
      
      // 处理对象类型（可能包含时间戳）
      if (typeof date === 'object' && date !== null) {
        if (date.time) {
          timestamp = date.time
        } else if (date.timestamp) {
          timestamp = date.timestamp
        } else {
          return ''
        }
      }
      // 处理数字类型（时间戳）
      else if (typeof date === 'number') {
        timestamp = date
      }
      // 处理字符串类型
      else if (typeof date === 'string') {
        // 如果是纯数字字符串，当作时间戳处理
        if (/^\d+$/.test(date)) {
          timestamp = parseInt(date)
        } else {
          // 尝试解析日期字符串
          const parsedDate = new Date(date)
          if (isNaN(parsedDate.getTime())) {
            return ''
          }
          timestamp = parsedDate.getTime()
        }
      } else {
        return ''
      }
      
      // 确保时间戳是毫秒级别的
      if (timestamp < 10000000000) {
        timestamp = timestamp * 1000
      }
      
      const dateObj = new Date(timestamp)
      
      // 检查日期是否有效
      if (isNaN(dateObj.getTime())) {
        return ''
      }
      
      // 格式化为 YYYY-MM-DD HH:mm:ss
      const year = dateObj.getFullYear()
      const month = String(dateObj.getMonth() + 1).padStart(2, '0')
      const day = String(dateObj.getDate()).padStart(2, '0')
      const hours = String(dateObj.getHours()).padStart(2, '0')
      const minutes = String(dateObj.getMinutes()).padStart(2, '0')
      const seconds = String(dateObj.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    // 格式化保险公司类型
    formatInsuranceType(insuranceType) {
      if (!insuranceType) {
        return '未选择'
      }
      
      const company = this.insuranceCompanyList.find(item => item.id == insuranceType)
      return company ? company.name : '未知保险公司'
    },

    // 格式化结算渠道
    formatSettlementChannel(value) {
      const channels = {
        1: '恒丰经纪',
        2: '中际心元',
        4: '鼎盛'
      }
      return channels[value] || '未知'
    },

    // 格式化布尔值
    formatBooleanValue(value) {
      return value ? '是' : '否'
    },
    
    // 获取搜索参数
    getSearchParams() {
      const params = {
        page: this.pagination.page,
        rows: this.pagination.rows
      }
      
      if (this.searchForm.createTimeRange && this.searchForm.createTimeRange.length === 2) {
        params.begin_time = this.searchForm.createTimeRange[0]
        params.end_time = this.searchForm.createTimeRange[1]
      }
      if (this.searchForm.insuranceType) params.insurance_type = this.searchForm.insuranceType
      if (this.searchForm.companyName) params.company_name = this.searchForm.companyName
      if (this.searchForm.settlementChannel) params.settlement_channel = this.searchForm.settlementChannel
      if (this.searchForm.policyName) params.policy_name = this.searchForm.policyName
      
      return params
    },
    
    resetSearchForm() {
      // 清空搜索表单
      this.searchForm = {
        createTimeRange: [],
        insuranceType: '',
        companyName: '',
        settlementChannel: '',
        policyName: ''
      }
    },
    
    // 搜索
    handleSearch() {
      this.pagination.page = 1
      this.fetchData()
    },
    
    // 重置
    handleReset() {
      this.resetSearchForm()
      this.pagination.page = 1
      this.fetchData()
    },
    
    // 选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },
    
    // 导出Excel
    handleExport() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要导出的数据')
        return
      }
      
      // 准备导出数据
      const exportData = this.selectedRows.map(row => ({
        '价格方案': row.priceSchemeName,
        '签署协议的公司名称': row.companyName,
        '保险公司类型': this.formatInsuranceType(row.insuranceType),
        '协议号': row.agreementNo,
        '结算渠道': this.formatSettlementChannel(row.settlementChannel),
        '是否在线充值': row.onlineRecharge === 1 ? '是' : '否',
        '是否自动支付': row.autoPay === 1 ? '是' : '否',
        '是否在线出单': row.onlinePolicy === 1 ? '是' : '否',
        '出单方案名称': row.policyName,
        '生效时间': row.effectiveTime,
        '失效时间': row.expireTime,
        '费用方案类型': row.feeSchemeType,
        '费率': row.rate,
        '最低保费': row.minPremium,
        '最高限额': row.maxLimit,
        '保单有效期': row.policyValidPeriod,
        '免赔额/率': row.deductible,
        '不保货物': row.excludedGoods,
        '电子保单特别约定': row.specialAgreement,
        '备注': row.remark,
        '创建时间': row.createTime,
        '更新时间': row.updateTime
      }))
      
      // 创建工作簿
      const ws = XLSX.utils.json_to_sheet(exportData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '价格方案')
      
      // 导出文件
      const fileName = `价格方案_${new Date().toISOString().slice(0, 10)}.xlsx`
      XLSX.writeFile(wb, fileName)
      
      this.$message.success('导出成功')
    },
    
    // 查看协议
    viewAgreement(url) {
      window.open(url, '_blank')
    },
    
    
    // 格式化结算渠道
    formatSettlementChannel(channel) {
      const channelMap = {
        '1': '恒丰经纪',
        '2': '中际心元',
        '4': '鼎盛'
      }
      return channelMap[channel] || channel
    },
    
    // 新增
    async handleAdd() {
      this.isEdit = false
      this.dialogTitle = '创建价格方案'
      this.resetSchemeForm()
      
      // 确保保险公司列表已加载
      if (this.insuranceCompanyList.length === 0) {
        await this.fetchInsuranceCompanyList()
      }
      
      this.dialogVisible = true
      this.fetchPolicyNameOptions()
    },
    
    // 获取保单名称选项
    async fetchPolicyNameOptions() {
      try {
        const response = await getPolicyNameList()
        if (response && response.err_code === 0) {
          // 根据老项目的数据结构，将返回的数据映射为选项格式
          this.policyNameOptions = (response.rows || []).map(item => ({
            value: item.policy_name,
            label: item.policy_name_desc
          }))
        } else {
          this.$message.error('获取出单方案列表失败')
        }
      } catch (error) {
        console.error('获取保单名称列表失败:', error)
        this.$message.error('获取出单方案列表失败')
        // 如果接口调用失败，保持空数组
        this.policyNameOptions = []
      }
    },
    
    // 编辑
    async handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑价格方案'
      
      // 确保保险公司列表已加载
      if (this.insuranceCompanyList.length === 0) {
        await this.fetchInsuranceCompanyList()
      }
      
      // 确保承保确认单样式选项已加载
      if (this.confirmationTypeOptions.length === 0) {
        await this.fetchConfirmationTypeList()
      }
      
      // 如果是从API获取的数据，需要调用API获取详细信息
      if (row.id) {
        this.fetchSchemeDetail(row.id)
      }
      
      this.dialogVisible = true
      this.fetchPolicyNameOptions()
    },
    
    // 获取方案详细信息（用于编辑）
    async fetchSchemeDetail(id) {
      this.loading = true
      try {
        // 调用实际的API接口获取详细信息
        const response = await getHyxPriceDetail({ id })
        if (response && response.err_code === 0) {
          // 根据老项目的数据结构，接口返回的数据包含：
          // response.data.HyxUserInfo - 主要方案信息
          // response.data.forbid_city_list - 不保地区列表
          // response.data.add_free_city_list - 加费地区列表
          const apiData = {
            ...response.data.HyxUserInfo,
            forbid_city_list: response.data.forbid_city_list || [],
            add_free_city_list: response.data.add_free_city_list || []
          }
          

          
          // 将API数据映射到表单
          this.mapApiDataToForm(apiData)
        } else {
          this.$message.error('获取方案详情失败：' + (response.err_msg || '未知错误'))
        }
      } catch (error) {
        console.error('获取方案详情失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    // 将API数据映射到表单
    mapApiDataToForm(apiData) {
      // 处理confirmation_type值，确保正确转换为字符串
      let confirmationTypeValue = ''
      if (apiData.confirmation_type !== null && apiData.confirmation_type !== undefined) {
        confirmationTypeValue = String(apiData.confirmation_type)
      }
      
      this.schemeForm = {
        id: apiData.id,
        priceSchemeName: apiData.name || '',
        companyName: apiData.company_name || '',
        insuranceType: this.formatInsuranceType(apiData.insurance_type),
        insuranceTypeId: apiData.insurance_type,
        settlementChannel: String(apiData.settlement_channel || ''),
        policyName: apiData.policy_name || '',
        confirmationType: confirmationTypeValue,
        // 修复数据类型转换：将布尔值转换为数字
        onlineRecharge: apiData.is_deposit_online === true ? 1 : 0,
        autoPay: apiData.is_auto_pay === true ? 1 : 0,
        onlinePolicy: apiData.is_get_policy === true ? 1 : 0,
        sendEmail: apiData.is_send_email === true ? 1 : 0,
        email: apiData.email || '',
        effectiveTime: this.formatDateForInput(apiData.effected_at),
        expireTime: this.formatDateForInput(apiData.expired_at),
        feeSchemeType: String(apiData.calculate_type || ''),
        rate: apiData.premium_rate ? (apiData.premium_rate / 10000).toString() : '',
        minPremium: apiData.min_premium ? apiData.min_premium.toString() : '',
        maxLimit: apiData.max_coverage ? apiData.max_coverage.toString() : '',
        deductible: apiData.deductible || '',
        policyValidPeriod: apiData.effect_days ? apiData.effect_days.toString() : '',
        agreementScanUrl: apiData.protocol_url || '',
        excludedGoods: apiData.warranty_against_cargo || '',
        specialAgreement: apiData.terms || '',
        protocolContent: apiData.protocol_content || '',
        additionalClauses: apiData.additional_clauses || '',
        insuranceLiability: apiData.insurance_liability || '',
        remark: apiData.note || '',
        // 新增字段
        isCityForbid: apiData.is_city_forbid === true,
        forbidCityList: apiData.forbid_city_list || [],
        isSuperCard: apiData.is_super_card === true,
        superCardFree: apiData.super_card_free === true ? 1 : 0,
        superCardAmount: apiData.super_card_amount ? apiData.super_card_amount.toString() : '',
        isCityFree: apiData.is_city_free === true,
        cityFree: apiData.city_free === true ? 1 : 0,
        cityAmount: apiData.city_amount ? apiData.city_amount.toString() : '',
        addFreeCityList: apiData.add_free_city_list || []
      }
      
      // 设置城市树的选中状态
      // 使用setTimeout确保DOM更新完成后再设置选中状态
      setTimeout(() => {
        // 设置不保地区树的选中状态
        if (this.schemeForm.isCityForbid && this.schemeForm.forbidCityList && this.schemeForm.forbidCityList.length > 0) {
          const forbidCityIds = this.schemeForm.forbidCityList.map(city => city.city_code || city.id)
          if (this.$refs.forbidCityTree) {
            this.$refs.forbidCityTree.setCheckedKeys(forbidCityIds)
          }
        }
        
        // 设置加费地区树的选中状态
        if (this.schemeForm.isCityFree && this.schemeForm.addFreeCityList && this.schemeForm.addFreeCityList.length > 0) {
          const addFreeCityIds = this.schemeForm.addFreeCityList.map(city => city.city_code || city.id)
          if (this.$refs.addFreeCityTree) {
            this.$refs.addFreeCityTree.setCheckedKeys(addFreeCityIds)
          }
        }
      }, 100)
    },
    
    // 解析保险公司类型值
    parseInsuranceTypeValue(value) {
      // 如果传入的是数字或数字字符串，直接返回字符串形式
      if (typeof value === 'number' || (typeof value === 'string' && /^\d+$/.test(value))) {
        return String(value)
      }
      
      // 如果传入的是保险公司名称，通过insuranceCompanyList查找对应的ID
      if (typeof value === 'string' && this.insuranceCompanyList.length > 0) {
        const company = this.insuranceCompanyList.find(item => item.name === value)
        return company ? String(company.id) : ''
      }
      
      return ''
    },
    
    // 解析结算渠道值
    parseSettlementChannelValue(text) {
      const mapping = {
        '恒丰经纪': '1',
        '中际心元': '2',
        '鼎盛': '4'
      }
      return mapping[text] || ''
    },
    
    // 解析费用方案类型值
    parseFeeSchemeTypeValue(text) {
      const mapping = {
        '保额*费率': '1',
        '运费*费率': '2',
        '固定费用': '3'
      }
      return mapping[text] || ''
    },
    
    // 格式化日期用于输入框
    formatDateForInput(date) {
      if (!date || date === '0001-01-01T00:00:00Z') {
        return ''
      }
      
      try {
        const d = new Date(date)
        if (isNaN(d.getTime())) {
          return ''
        }
        return d.toISOString().split('T')[0]
      } catch (error) {
        return ''
      }
    },
    
    // 获取城市列表
    async fetchCityList() {
      try {
        // 调用接口获取城市数据
        const response = await getCityList()
        
        if (response && response.err_code === 0 && response.rows) {
          // 检查接口返回的数据是否完整（应该有30+个省份）
          if (response.rows.length < 10) {
            this.cityTreeData = this.formatStandardCityData(CITIES_DATA)
            return
          }
          
          // 完全按照旧项目的方式处理数据
          response.rows.map((item, index) => {
            item.text = item.province
            if (item.children) {
              for (let i = 0; i < item.children.length; i++) {
                item.children[i].text = item.children[i].city
              }
            }
          })
          
          // 直接使用处理后的数据
          this.cityTreeData = response.rows
        } else {
          // 使用静态城市数据作为后备
          this.cityTreeData = this.formatStandardCityData(CITIES_DATA)
        }
      } catch (error) {
        console.error('获取城市列表失败:', error)
        // 使用静态城市数据作为后备
        this.cityTreeData = this.formatStandardCityData(CITIES_DATA)
      }
    },
    
    // 格式化城市树数据
    formatCityTreeData(data) {
      return data.map(province => ({
        id: province.province_code || province.id,
        text: province.province,
        children: province.children ? province.children.map(city => ({
          id: city.city_code || city.id,
          text: city.city
        })) : []
      }))
    },
    
    // 格式化标准城市数据
    formatStandardCityData(data) {
      // 如果数据已经包含value字段（行政区划代码），直接使用
      if (data.length > 0 && data[0].value) {
        return this.formatOldCityData(data)
      }
      
      // 否则使用新的简化数据格式
      return data.map((province, provinceIndex) => ({
        id: `province_${provinceIndex}`,
        text: province.name,
        children: province.city ? province.city.map((city, cityIndex) => ({
          id: `city_${provinceIndex}_${cityIndex}`,
          text: city.name,
          children: city.area ? city.area.map((area, areaIndex) => ({
            id: `area_${provinceIndex}_${cityIndex}_${areaIndex}`,
            text: area
          })) : []
        })) : []
      }))
    },
    
    // 格式化旧项目的城市数据（包含行政区划代码）
    formatOldCityData(data) {
      return data.map(province => ({
        id: province.value,
        text: province.label,
        children: province.children ? province.children.map(city => ({
          id: city.value,
          text: city.label,
          children: city.children ? city.children.map(area => ({
            id: area.value,
            text: area.label
          })) : []
        })) : []
      }))
    },
    
    // 获取承保确认单样式选项
    async fetchConfirmationTypeList() {
      try {
        // 调用实际的API接口
        const response = await getConfirmationTypeList()
        if (response && response.err_code === 0) {
          this.confirmationTypeOptions = response.rows.map(item => ({
            value: String(item.confirmation_type),
            label: item.confirmation_type_desc
          }))
        } else {
          // 使用模拟数据作为后备
          this.confirmationTypeOptions = [
            { value: '1', label: '标准样式' },
            { value: '2', label: '简约样式' },
            { value: '3', label: '详细样式' },
            { value: '4', label: '企业定制样式' }
          ]
        }
      } catch (error) {
        console.error('获取承保确认单样式选项失败:', error)
        // 使用模拟数据作为后备
        this.confirmationTypeOptions = [
          { value: '1', label: '标准样式' },
          { value: '2', label: '简约样式' },
          { value: '3', label: '详细样式' },
          { value: '4', label: '企业定制样式' }
        ]
      }
    },
    

    
    // 处理不保地区选择
    handleForbidCityCheck(data, checked) {
      const checkedNodes = this.$refs.forbidCityTree.getCheckedNodes()
      // 只获取叶子节点（城市节点）
      const cityList = checkedNodes.filter(node => !node.children || node.children.length === 0)
      
      this.schemeForm.forbidCityList = cityList.map(city => ({
        city_code: city.id,
        city_name: city.text,
        province_code: this.getProvinceCodeByCity(city.id),
        province_name: this.getProvinceNameByCity(city.id)
      }))
    },
    
    // 处理加费地区选择
    handleAddFreeCityCheck(data, checked) {
      const checkedNodes = this.$refs.addFreeCityTree.getCheckedNodes()
      // 只获取叶子节点（城市节点）
      const cityList = checkedNodes.filter(node => !node.children || node.children.length === 0)
      
      this.schemeForm.addFreeCityList = cityList.map(city => ({
        city_code: city.id,
        city_name: city.text,
        province_code: this.getProvinceCodeByCity(city.id),
        province_name: this.getProvinceNameByCity(city.id)
      }))
    },
    
    // 重置表单
    resetSchemeForm() {
      this.schemeForm = {
        id: null,
        priceSchemeName: '',
        companyName: '',
        insuranceType: '',
        agreementNo: '',
        settlementChannel: '',
        policyName: '',
        onlineRecharge: 1,
        autoPay: 0,
        onlinePolicy: 1,
        sendEmail: 0,
        email: '',
        effectiveTime: '',
        expireTime: '',
        feeSchemeType: '',
        rate: '',
        minPremium: '',
        maxLimit: '',
        deductible: '',
        policyValidPeriod: '',
        agreementScanUrl: '',
        excludedGoods: '',
        specialAgreement: '',
        protocolContent: '',
        additionalClauses: '',
        insuranceLiability: '',
        remark: '',
        // 新增字段
        isCityForbid: false,
        forbidCityList: [],
        isSuperCard: false,
        superCardFree: 0,
        superCardAmount: '',
        isCityFree: false,
        cityFree: 0,
        cityAmount: '',
        addFreeCityList: []
      }
      if (this.$refs.schemeForm) {
        this.$refs.schemeForm.clearValidate()
      }
      // 清空城市树选择
      this.$nextTick(() => {
        this.$refs.forbidCityTree && this.$refs.forbidCityTree.setCheckedKeys([])
        this.$refs.addFreeCityTree && this.$refs.addFreeCityTree.setCheckedKeys([])
      })
    },
    
    // 切换状态
    async handleToggleStatus(row) {
      const action = row.status === '1' ? '禁用' : '启用'
      try {
        await this.$confirm(`确认${action}该方案？`, '提示', { type: 'warning' })
        // TODO: 调用实际的API接口
        // await toggleSchemeStatus(row.id, row.status === '1' ? '0' : '1')
        
        this.$message.success(`${action}成功`)
        this.fetchData()
      } catch (e) {
        // 用户取消操作
      }
    },
    
    // 删除
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该价格方案？删除后不可恢复！', '提示', { type: 'warning' })
        
        const response = await deleteHyxPriceScheme({ id: row.id })
        if (response.err_code === 0) {
          this.$message.success('删除成功')
          this.fetchData()
        } else {
          this.$message.error(response.data.err_msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除价格方案失败:', error)
          this.$message.error('删除失败，请稍后重试')
        }
      }
    },
    
    // 提交表单
    handleSubmit() {
      this.$refs.schemeForm.validate(async (valid) => {
        if (valid) {
          // 验证时间范围
          if (this.schemeForm.effectiveTime && this.schemeForm.expireTime) {
            if (new Date(this.schemeForm.effectiveTime) >= new Date(this.schemeForm.expireTime)) {
              this.$message.error('生效时间必须早于失效时间')
              return
            }
          }
          
          // 验证邮箱
          if (this.schemeForm.sendEmail === 1 && !this.schemeForm.email) {
            this.$message.error('选择发送邮件时，邮箱地址不能为空')
            return
          }
          
          this.submitLoading = true
          
          try {
            // 获取城市树选中的数据
            const forbidCityList = this.getForbidCityListFromTree()
            const addFreeCityList = this.getAddFreeCityListFromTree()
            
            // 准备提交数据 - 按照老项目的参数格式
            const submitData = {
              // 编辑时需要传递id
              ...(this.isEdit && this.schemeForm.id ? { id: this.schemeForm.id } : {}),
              
              // 基本信息 - 使用下划线命名格式
               name: this.schemeForm.priceSchemeName,
               company_name: this.schemeForm.companyName,
               insurance_type: this.isEdit?this.schemeForm.insuranceTypeId:this.schemeForm.insuranceType,
               settlement_channel: parseInt(this.schemeForm.settlementChannel) || 0,
               protocol_url: this.schemeForm.agreementScanUrl,
               
               // 费用相关 - 按照老项目的格式
               premium_rate: this.schemeForm.rate ? Number((parseFloat(this.schemeForm.rate) * 10000).toFixed(0)) : 0,
               min_premium: this.schemeForm.minPremium ? parseFloat(this.schemeForm.minPremium) : 0,
               max_coverage: this.schemeForm.maxLimit ? parseFloat(this.schemeForm.maxLimit) : 0,
               calculate_type: parseInt(this.schemeForm.feeSchemeType) || 1,
              
              // 时间相关 - 使用字符串格式（与老项目一致）
               effected_at: this.schemeForm.effectiveTime.length>10?this.schemeForm.effectiveTime.substr(0,10):this.schemeForm.effectiveTime,
               expired_at: this.schemeForm.expireTime.length>10?this.schemeForm.expireTime.substr(0,10):this.schemeForm.expireTime,
               effect_days: this.schemeForm.policyValidPeriod ? parseInt(this.schemeForm.policyValidPeriod) : 10,
               
               // 开关设置
               is_auto_pay: this.schemeForm.autoPay === 1,
               is_deposit_online: this.schemeForm.onlineRecharge === 1,
               is_get_policy: this.schemeForm.onlinePolicy === 1,
               is_send_email: this.schemeForm.sendEmail === 1,
               
               // 邮箱
               email: this.schemeForm.email || '',
               
               // 出单方案和承保确认单样式
               policy_name: parseInt(this.schemeForm.policyName),
               confirmation_type: this.schemeForm.confirmationType ? parseInt(this.schemeForm.confirmationType) : 0,
              
              // 超牌车辆设置
              is_super_card: this.schemeForm.isSuperCard,
              super_card_free: this.schemeForm.superCardFeeType || 1,
              amount_or_rate: this.schemeForm.superCardFeeType === 1 ? 0 : 
                             this.schemeForm.superCardFeeType === 2 ? 
                             Number((parseFloat(this.schemeForm.superCardAmount || 0) * 100).toFixed(0)) : 
                             Number((parseFloat(this.schemeForm.superCardRate || 0) * 10000).toFixed(0)),
              
              // 城市加费设置
               is_city_free: this.schemeForm.isCityFree,
               city_free: this.schemeForm.cityFeeType || 0,
               city_amount_or_rate: this.schemeForm.cityFeeType === 1 ? 
                                   Number((parseFloat(this.schemeForm.cityFeeAmount || 0) * 100).toFixed(0)) : 
                                   Number((parseFloat(this.schemeForm.cityFeeRate || 0) * 10000).toFixed(0)),
              
              // 不保地区设置
              is_city_forbid: this.schemeForm.isCityForbid,
              forbid_city_list: forbidCityList,
              add_free_city_list: addFreeCityList,
              
              // 其他信息
              deductible: this.schemeForm.deductible || '',
              warranty_against_cargo: this.schemeForm.excludedGoods || '',
              terms: this.schemeForm.specialAgreement || '',
              note: this.schemeForm.remark || '',
              protocol_content: this.schemeForm.protocolContent || '',
              additional_clauses: this.schemeForm.additionalClauses || '',
              insurance_liability: this.schemeForm.insuranceLiability || ''
            }
            
            // 调用实际的API接口保存数据
            const response = await saveHyxPrice(submitData)
            if (response && response.err_code === 0) {
              this.$message.success(this.isEdit ? '编辑成功' : '创建成功')
            } else {
              throw new Error(response.err_msg || '保存失败')
            }
            this.dialogVisible = false
            this.fetchData()
          } catch (error) {
            console.error('提交失败:', error)
            this.$message.error('提交失败，请重试')
          } finally {
            this.submitLoading = false
          }
        } else {
          this.$message.error('请完善必填信息')
        }
      })
    },
    
    // 对话框关闭
    handleDialogClose() {
      this.resetSchemeForm()
    },
    
    // 文件上传前的钩子
    handleBeforeUpload(file) {
      // 检查文件类型
      const isValidType = file.type === 'application/pdf' || 
                         file.type === 'image/jpeg' || 
                         file.type === 'image/png' || 
                         file.type === 'image/jpg'
      
      if (!isValidType) {
        this.$message.error('只能上传 PDF、JPG、PNG 格式的文件!')
        return false
      }
      
      // 检查文件大小
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
        return false
      }
      
      return true
    },
    
    // 文件上传成功的钩子
    handleUploadSuccess(response, file) {
      if (response && response.err_code === 0) {
        // 上传成功，将文件URL保存到表单中
        this.schemeForm.agreementScanUrl = response.data
        this.$message.success('文件上传成功')
      } else {
        this.$message.error(response.err_msg || '文件上传失败')
      }
    },
    
    // 文件上传失败的钩子
    handleUploadError(err, file) {
      console.error('文件上传失败:', err)
      this.$message.error('文件上传失败，请重试')
    },
    
    // 重置表单
    resetForm() {
      this.form = {
        id: null,
        schemeName: '',
        description: '',
        minCargoValue: null,
        maxCargoValue: null,
        rate: null,
        minPremium: null,
        status: '1'
      }
    },
    
    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.rows = val
      this.pagination.page = 1
      this.fetchData()
    },
    
    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.page = val
      this.fetchData()
    },
    
    // 获取不保地区城市树选中的数据
    getForbidCityListFromTree() {
      if (!this.$refs.forbidCityTree) {
        return []
      }
      
      const checkedKeys = this.$refs.forbidCityTree.getCheckedKeys()
      const checkedNodes = this.$refs.forbidCityTree.getCheckedNodes()
      
      // 只获取叶子节点（城市节点）
      const cityList = checkedNodes.filter(node => !node.children || node.children.length === 0)
      
      return cityList.map(city => ({
        id: city.id,
        city: city.text,
        province: this.getProvinceNameByCity(city.id)
      }))
    },
    
    // 获取新增免费城市树选中的数据
    getAddFreeCityListFromTree() {
      if (!this.$refs.addFreeCityTree) {
        return []
      }
      
      const checkedKeys = this.$refs.addFreeCityTree.getCheckedKeys()
      const checkedNodes = this.$refs.addFreeCityTree.getCheckedNodes()
      
      // 只获取叶子节点（城市节点）
      const cityList = checkedNodes.filter(node => !node.children || node.children.length === 0)
      
      return cityList.map(city => ({
        id: city.id,
        city: city.text,
        province: this.getProvinceNameByCity(city.id)
      }))
    },
    
    // 根据城市ID获取省份代码
    getProvinceCodeByCity(cityId) {
      for (const province of this.cityTreeData) {
        if (province.children) {
          for (const city of province.children) {
            if (city.id === cityId) {
              return province.id
            }
          }
        }
      }
      return ''
    },
    
    // 根据城市ID获取省份名称
    getProvinceNameByCity(cityId) {
      for (const province of this.cityTreeData) {
        if (province.children) {
          for (const city of province.children) {
            if (city.id === cityId) {
              return province.text
            }
          }
        }
      }
      return ''
    }
  }
}
</script>

<style lang="less" scoped>
.appointment-freight-pricing-scheme {
  .search-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    padding: 20px;
    background: #f5f5f5;
    border-radius: 4px;
  }
  
  .search-form {
    flex: 1;
  }
  
  .toolbar-right {
    margin-left: 20px;
    
    .el-button {
      margin-left: 10px;
    }
  }
  
  .pagination-wrapper {
    margin-top: 20px;
    text-align: right;
  }
  
  // 表格容器样式
  .table-container {
    overflow-x: auto;
    width: 100%;
    
    // 滚动条样式优化
    &::-webkit-scrollbar {
      height: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
  }
  
  // 表格样式优化
  .el-table {
    font-size: 12px;
    
    .el-table__header th {
      background-color: #fafafa;
      color: #333;
      font-weight: 600;
      white-space: nowrap;
    }
    
    .el-table__body td {
      padding: 8px 0;
      white-space: nowrap;
    }
    
    // 确保表格内容不换行
    .el-table__body .cell {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    
    .el-table__header .cell {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  
  // 标签样式
  .el-tag {
    font-size: 11px;
  }
  
  // 按钮样式
  .el-button--mini {
    padding: 4px 8px;
    font-size: 11px;
  }
}
</style>
